import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/showToaster";
import FollowupForm from "./AddFollowupNote";
import { FuturePurchaseFollowupNote } from "src/models/FuturePurchase.model";
import { useAddFollowupNoteMutation } from "src/services/FollowupNoteService";

type Props = {
  onClose: () => void;
  selectedFuturePurchaseId: any;
};

const FollowupFormWrapper = ({ onClose, selectedFuturePurchaseId }: Props) => {
  // Form Initial Values
  const initialValues: FuturePurchaseFollowupNote = {
    futurePurchaseId: selectedFuturePurchaseId,
    note: "",
    nextfollowupNoteRequired: true,
    nextfollowupNoteDate: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    note: string().required("Note is required"),
    nextfollowupNoteDate:string().required("Next Date is required"),
  });

  const [AddFollowupNote] = useAddFollowupNoteMutation();

  // Handle Submit
  const handleSubmit = (
    values: FuturePurchaseFollowupNote,
    { setSubmitting, resetForm }: FormikHelpers<FuturePurchaseFollowupNote>
  ) => {
   
    AddFollowupNote(values).then(
      (res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
            resetForm();
            onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      }
    );
  };

  return (
    <Dialog open maxWidth="sm" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <FollowupForm formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default FollowupFormWrapper;
